"use client";
import "@repo/edtech-ui-kit/styles";
import { jsxs as p, jsx as d, Fragment as R } from "react/jsx-runtime";
import { useRef as V, useEffect as E, useMemo as j } from "react";
import { useScopedPortal as S, isIos as I, useIsMobile as O, EdtechProvider as D } from "@repo/edtech-shared";
import { usePlayerStore as i, PlayerType as e, usePlayerAllActions as k, formatToHHMMSS as T, FormatMode as q, getPlayIcon as z, usePlayerSlotManager as $, usePlayerTeleport as F, usePipInteractions as G, formatTime as B, initPlayerStores as J, MOBILE_WIDTH as K } from "@repo/edtech-video-player-utils";
import { PlayPauseButton as Q, PlayerProgressBar as L, OverlayPlayPauseButton as U } from "@repo/edtech-ui-kit";
import { PipExitIcon as X, CrossIcon as Y } from "@repo/edtech-assets";
function W(n) {
  var l, t, o = "";
  if (typeof n == "string" || typeof n == "number") o += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var a = n.length;
    for (l = 0; l < a; l++) n[l] && (t = W(n[l])) && (o && (o += " "), o += t);
  } else for (t in n) n[t] && (o && (o += " "), o += t);
  return o;
}
function N() {
  for (var n, l, t = 0, o = "", a = arguments.length; t < a; t++) (n = arguments[t]) && (l = W(n)) && (o && (o += " "), o += l);
  return o;
}
const Z = "_audio_mini_player_4sxzu_1", ee = "_hidden_4sxzu_17", oe = "_header_4sxzu_21", ie = "_title_4sxzu_27", ne = "_timer_4sxzu_34", te = "_player_4sxzu_38", P = {
  audio_mini_player: Z,
  hidden: ee,
  header: oe,
  title: ie,
  timer: ne,
  player: te
}, se = ({ miniPlayerRef: n }) => {
  const l = i(e.Audio, (s) => s.title), t = i(e.Audio, (s) => s.playing), o = i(e.Audio, (s) => s.ended), a = i(e.Audio, (s) => s.currentTime), u = i(e.Audio, (s) => s.duration), y = i(e.Audio, (s) => s.isMini), {
    toggle: f,
    seekTo: b,
    triggerMiniBackButton: h
  } = k(e.Audio);
  return /* @__PURE__ */ p("div", { className: N(P.audio_mini_player, !y && P.hidden), children: [
    /* @__PURE__ */ p("div", { className: P.header, children: [
      /* @__PURE__ */ d(
        "button",
        {
          className: P.title,
          onClick: () => h(),
          children: l
        }
      ),
      /* @__PURE__ */ p("span", { className: P.timer, children: [
        T(a, q.MS),
        "/",
        T(u, q.MS)
      ] })
    ] }),
    /* @__PURE__ */ p(
      "div",
      {
        ref: n,
        className: P.player,
        children: [
          /* @__PURE__ */ d(
            Q,
            {
              Icon: z(t, o),
              onClick: f
            }
          ),
          /* @__PURE__ */ d(
            L,
            {
              currentTime: a,
              duration: u,
              seekTo: b
            }
          )
        ]
      }
    )
  ] });
}, re = "_hidden_hlwdf_24", le = {
  hidden: re
}, ae = ({ targetAttribute: n = "data-audio-slot" }) => {
  const l = S(), t = V(null), o = V(null), a = V(null), u = i(e.Audio, (_) => _.source), y = i(e.Audio, (_) => _.id), f = i(e.Audio, (_) => _.isMini), b = i(e.Audio, (_) => _.playerEl), h = i(e.Audio, (_) => _.playerWrapEl), {
    setPlayerEl: s,
    play: g
  } = k(e.Audio), {
    targetEl: M,
    isReady: v
  } = $(n, y ?? "");
  return F({
    element: b,
    isMini: f,
    mini: a.current,
    slot: M,
    base: o.current,
    baseMini: h
  }), E(() => {
    g();
  }, [g, u]), /* @__PURE__ */ p(R, { children: [
    /* @__PURE__ */ d(
      "div",
      {
        ref: o,
        className: N(!v && le.hidden),
        id: "edt-audio-player-manager",
        children: /* @__PURE__ */ d("div", { ref: t, children: /* @__PURE__ */ d(
          "audio",
          {
            ref: s,
            src: u || void 0
          }
        ) })
      }
    ),
    l(/* @__PURE__ */ d(se, { miniPlayerRef: a }), document.body)
  ] });
}, de = "_wrapper_gqm8o_1", ce = "_hidden_gqm8o_13", ue = "_player_gqm8o_17", _e = "_top_buttons_gqm8o_26", pe = "_button_gqm8o_35", me = "_pip_exit_gqm8o_44", ye = "_controls_gqm8o_55", fe = "_time_gqm8o_64", he = "_close_icon_gqm8o_69", ge = "_title_gqm8o_78", m = {
  wrapper: de,
  hidden: ce,
  player: ue,
  top_buttons: _e,
  button: pe,
  pip_exit: me,
  controls: ye,
  time: fe,
  close_icon: he,
  title: ge
}, ve = ({ miniPlayerRef: n }) => {
  const {
    pipRef: l,
    dragHandleRef: t,
    position: o
  } = G(), a = i(e.Video, (r) => r.playing), u = i(e.Video, (r) => r.ended), y = i(e.Video, (r) => r.currentTime), f = i(e.Video, (r) => r.duration), b = i(e.Video, (r) => r.title), h = i(e.Video, (r) => r.isShowingControls), s = i(e.Video, (r) => r.isMini), {
    seekTo: g,
    showControlsForLimitedTime: M,
    showControlsPermanently: v,
    handleControlsPlayButtonClick: _,
    triggerMiniBackButton: x,
    reset: C
  } = k(e.Video), w = (r) => r.stopPropagation(), c = (r) => {
    w(r), M(), x();
  }, H = (r) => {
    w(r), C();
  };
  return /* @__PURE__ */ p(
    "div",
    {
      ref: l,
      className: N(m.wrapper, !s && m.hidden),
      id: "edt-video-player-pip",
      style: {
        left: o.x,
        top: o.y
      },
      children: [
        /* @__PURE__ */ p(
          "div",
          {
            ref: n,
            className: m.player,
            children: [
              /* @__PURE__ */ d(
                U,
                {
                  ended: u,
                  Icon: z(a, u),
                  isShowingControls: h,
                  playing: a,
                  onClick: _,
                  onMouseLeave: M,
                  onMouseMove: v
                }
              ),
              h && /* @__PURE__ */ p("div", { className: m.top_buttons, children: [
                /* @__PURE__ */ d(
                  "button",
                  {
                    className: m.button,
                    onClick: c,
                    onMouseLeave: M,
                    onMouseMove: v,
                    children: /* @__PURE__ */ d(X, { className: m.pip_exit })
                  }
                ),
                /* @__PURE__ */ d(
                  "button",
                  {
                    className: m.button,
                    onClick: H,
                    onMouseLeave: M,
                    onMouseMove: v,
                    children: /* @__PURE__ */ d(Y, { className: m.close_icon })
                  }
                )
              ] }),
              /* @__PURE__ */ p("div", { className: m.controls, children: [
                /* @__PURE__ */ p("span", { className: m.time, children: [
                  B(y),
                  " / ",
                  B(f)
                ] }),
                /* @__PURE__ */ d(
                  L,
                  {
                    isPip: !0,
                    currentTime: y,
                    duration: f,
                    seekTo: g
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ p(
          "h3",
          {
            ref: t,
            className: m.title,
            children: [
              "Видео: ",
              b
            ]
          }
        )
      ]
    }
  );
}, Me = "_hidden_vk9vk_1", be = "_video_vk9vk_5", Pe = "_fullscreen_mode_vk9vk_11", ke = "_pip_mode_vk9vk_16", Ae = "_no_border_radius_vk9vk_20", A = {
  hidden: Me,
  video: be,
  fullscreen_mode: Pe,
  pip_mode: ke,
  no_border_radius: Ae
}, Ve = ({ targetAttribute: n = "data-video-slot", withoutBorderRadius: l = !1 }) => {
  const t = S(), o = V(null), a = V(null), {
    setPlayerEl: u,
    bindVideoEvents: y
  } = k(e.Video), f = i(e.Video, (c) => c.source), b = i(e.Video, (c) => c.id), h = i(e.Video, (c) => c.isMini), s = i(e.Video, (c) => c.isFullscreen), g = i(e.Video, (c) => c.playerEl), M = i(e.Video, (c) => c.playerWrapEl), v = i(e.Video, (c) => c.clipMode), _ = i(e.Video, (c) => c.muted), { targetEl: x } = $(n, b ?? ""), C = !s && I(), w = s && I();
  return F({
    element: g,
    isMini: h,
    mini: o.current,
    slot: x,
    base: a.current,
    baseMini: M
  }), E(() => {
    if (g)
      return y(g, v);
  }, [
    y,
    v,
    g,
    C
  ]), /* @__PURE__ */ p(
    "div",
    {
      ref: a,
      className: N("edtech-player-manager", A.hidden),
      id: "edt-video-player-manager",
      children: [
        /* @__PURE__ */ d(
          "video",
          {
            ref: u,
            autoPlay: !!v,
            className: N(
              A.video,
              s && A.fullscreen_mode,
              h && A.pip_mode,
              l && A.no_border_radius
            ),
            controls: w,
            muted: _,
            playsInline: !0,
            preload: "auto",
            src: f || void 0,
            tabIndex: 0
          }
        ),
        t(/* @__PURE__ */ d(ve, { miniPlayerRef: o }), document.body)
      ]
    }
  );
};
J();
const qe = ({ targetAttribute: n, withoutBorderRadius: l = !1 }) => {
  const t = O(K), o = j(() => {
    if (window !== void 0)
      return window.globalPlayerManagerInitialized ? !1 : (window.globalPlayerManagerInitialized = !0, !0);
  }, []), { setMobile: a } = k(e.Video), { setMobile: u } = k(e.Audio);
  return E(() => {
    o && (u(t), a(t));
  }, [
    t,
    o,
    u,
    a
  ]), E(() => {
    if (o)
      return () => {
        window.globalPlayerManagerInitialized = !1;
      };
  }, [o]), o ? /* @__PURE__ */ p(D, { name: "player-manager", children: [
    /* @__PURE__ */ d(ae, { targetAttribute: n }),
    /* @__PURE__ */ d(
      Ve,
      {
        targetAttribute: n,
        withoutBorderRadius: l
      }
    )
  ] }) : /* @__PURE__ */ d(R, {});
};
export {
  qe as EdtechPlayerManager
};
